/*
     Title: Constant for BUNDLE
     Description: Constant for BUNDLE
     Author: Iqbal Hossain
     Date: 23-January-2022
     Modified: 23-January-2022
*/

export const FETCH_BUNDLE = 'FETCH_BUNDLE';
export const FETCH_BUNDLE_BY_QUERY = 'FETCH_BUNDLE_BY_QUERY';
export const FETCH_BUNDLE_BY_ID = 'FETCH_BUNDLE_BY_ID';
export const FETCH_BUNDLE_BY_RANGE = 'FETCH_BUNDLE_BY_RANGE';

/** Change Log
 * 23-Jan-2022(Iqbal): Add FETCH_BUNDLE_BY_QUERY, , FETCH_BUNDLE, FETCH_BUNDLE_BY_ID, FETCH_BUNDLE_BY_RANGE
 */
